import React, {useEffect, useState, Fragment} from "react";
import "./chat-otp.less";
import NumberFormat from 'react-number-format';
import {ChatOTPFormProps} from "../../types/chat-msg-types";
import { useDispatch, useSelector } from "react-redux";
import { submitOtpKillSwitchAction, resendOtpKillSwitchAction, resetOtpKillSwitchAction } from "../../actions/chat-authentication-actions";
import { getKillSwitchSendOtpInfo, getCanClickSubmit, getCanClickResend, getResetOtp } from "../../reducers/chat-authentication-reducer";
import triangleError from "@/assets/triangle-error.svg";

const ChatOtp: React.FC<ChatOTPFormProps> = (props: ChatOTPFormProps) => {
    const dispatch = useDispatch();
    const [otpCode, setOtpCode] = useState("");
    const [otpMaskCode, setOtpMskCode] = useState("");
    const isHistoryMsg = props.isHistoryMsg;
    const actionId = props.actionId;
    const killSwitchSendOtpInfo = useSelector(getKillSwitchSendOtpInfo);
    const canClickSubmit = useSelector(getCanClickSubmit);
    const canClickResend = useSelector(getCanClickResend);
    const resetOtp = useSelector(getResetOtp);
    useEffect(() => {
        if(resetOtp) {
            console.log("need to reset otp");
            setOtpCode("");
        }
    },[resetOtp])
    return (
        <>
            <div className="chat-otp-main" data-testid="chat-otp">
                <NumberFormat value={otpCode} onValueChange={(values) => {
                    if(resetOtp) {
                        dispatch(resetOtpKillSwitchAction(false));
                    }
                    setOtpCode(values.value);
                }} className="chat-otp-input" format={"# # # # # #"} disabled={isHistoryMsg}></NumberFormat>
                {/* }} className="chat-otp-input" type={'password'} autoComplete="false" maxLength={6} disabled={isHistoryMsg}></NumberFormat> */}
                <div className={(!isHistoryMsg && killSwitchSendOtpInfo) ? "chat-otp-underline-all-error" : "chat-otp-underline-all"}>
                    <div className="chat-otp-underline">{otpCode.toLowerCase().length >= 1 && <span>.</span>}</div>
                    <div className="chat-otp-underline">{otpCode.toLowerCase().length >= 2 && <span>.</span>}</div>
                    <div className="chat-otp-underline">{otpCode.toLowerCase().length >= 3 && <span>.</span>}</div>
                    <div className="chat-otp-underline">{otpCode.toLowerCase().length >= 4 && <span>.</span>}</div>
                    <div className="chat-otp-underline">{otpCode.toLowerCase().length >= 5 && <span>.</span>}</div>
                    <div className="chat-otp-underline">{otpCode.toLowerCase().length >= 6 && <span>.</span>}</div>
                </div>
                {(!isHistoryMsg && killSwitchSendOtpInfo) && <p className="chat-otp-error"><img src={triangleError} alt="error"/>{killSwitchSendOtpInfo}</p>}
                {/* {killSwitchSendOtpInfo && <p className="chat-otp-error"><img src={triangleError} />{killSwitchSendOtpInfo}</p>} */}
                {
                    isHistoryMsg ? 
                    <div className="chat-otp-button-main">
                        {(props.btns)&&props.btns.map((item, index) =>
                            <button key={index} disabled className="chat-otp-button-item item-disable">{item.title}</button>
                        )}
                    </div>
                    :
                    <div className="chat-otp-button-main">
                        {(props.btns)&&props.btns.map((item, index) =>
                            <Fragment key={index}>
                                {item.actionCode === "resendOtp" && <button className="chat-otp-button-item resend" disabled={canClickResend?false:true} data-testid="resend-btn"
                                    onClick={() => {
                                        // console.log("kill switch resned");
                                        dispatch(resendOtpKillSwitchAction({actionId: actionId,type: item.actionCode, otp: otpCode, controlFlow: item.controlFlow}));
                                    }}>{item.title}</button>
                                }
                                {item.actionCode === "kba" && 
                                    <button className="chat-otp-button-item kba" disabled={(canClickSubmit && canClickSubmit > 0 )? false:true} data-testid="submit-btn" onClick={() => {
                                        // console.log("kill switch submit");
                                        if(otpCode && otpCode.length === 6) {
                                            dispatch(submitOtpKillSwitchAction({actionId: actionId,type: item.actionCode, otp: otpCode, controlFlow: item.controlFlow}));
                                        }
                                    }} >{item.title}</button>
                                }
                                {
                                    (item.actionCode != "kba" && item.actionCode != "resendOtp") && <button className="chat-otp-button-item">{item.title}</button>
                                }
                            </Fragment>
                        )}
                    </div>
                }
            </div>
        </>
    )
}

export default ChatOtp;